<template>
  <div class="widget-info box flex column text-truncate animated fadeInRight" v-show="!isLoading">
    <el-divider></el-divider>
    <div class="flex">
      <div class="box grow flex column">
        <div class="box grow body1 pre-wrap alert-color">{{ title }}</div>
        <div class="box subtitle2 alert-color">Past 24 hours</div>
      </div>
      <div class="box body1 justify-right alert-color" @click.stop="userClick">
        {{ renderAnomalyInsights || 0 }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ANOMALIES_SUMMARY_REQ } from '@/store/modules/anomalies/anomalies.type'

export default {
  name: 'AnomaliesInfoCard',
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    anomalyType: {
      type: [String, Array],
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      isLoading: true,
      anomalyInsights: []
    }
  },
  mounted () {
    this.$store
      .dispatch(ANOMALIES_SUMMARY_REQ, {
        dateRangeSel: 'PAST_24_HOURS'
      })
      .then(apiResponse => {
        this.anomalyInsights = this.anomalySummary.anomalyCategoryCount
        this.isLoading = false
      })
  },
  methods: {
    userClick () {
      this.$emit('insights-click', this.anomalyInsights)
    }
  },
  computed: {
    ...mapGetters(['anomalySummary']),
    renderAnomalyInsights () {
      switch (this.anomalyType) {
        case 'LOGIN_ANOMALY':
          return this.anomalyInsights.LOGIN_ANOMALY
        default:
          return this.anomalyInsights.LOGIN_ANOMALY
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  margin-top: 0px;
  margin-bottom: 5px;
}

span {
  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

.pre-wrap {
  width: 90%;
  white-space: pre-wrap;
  word-break: break-word;
}

.justify-right {
  text-align: right;
}

.alert-color {
  color: var(--amaranth-400);
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/AnomaliesInfoCard.vue